import { DefaultError } from 'errors/DefaultError';
import { ErrorResponse, NormalizedResponseError } from './types';
export class SessionError extends DefaultError {
  constructor({ error }: { error?: ErrorResponse }) {
    const shortMsg = `${error?.config?.method?.toUpperCase()} ${
      error?.config?.url
    } ${error?.status} (${error?.statusText})`;

    super({
      error: new Error(shortMsg),
      name: SessionError.name,
      title: 'Session expired',
      message: 'Please go back and try getting your quote again.'
    });
    const errorsArray: NormalizedResponseError[] = error?.data?.errors?.length
      ? error.data.errors
      : [];
    this.response = { errors: errorsArray };
  }
  static get name() {
    return 'SessionError';
  }
}
